import { useRef, useCallback } from 'react';

/**
 * Mutable refs and lifecycle handlers for the LT+ checkout signup flow.
 * Refs (not state) avoid re-renders that would race with speculation/pricing.
 */
export const useCheckoutLtPlusFlow = () => {
  const isCompletingLtPlusSubscriptionRef = useRef(false);
  const ltPlusSubscriptionIdRef = useRef(null);
  const postLtPlusSpeculatedTransactionRef = useRef(null);

  const handleBeginLtPlusSignup = useCallback(() => {
    isCompletingLtPlusSubscriptionRef.current = true;
  }, []);

  const handleEndLtPlusSignup = useCallback(() => {
    isCompletingLtPlusSubscriptionRef.current = false;
    ltPlusSubscriptionIdRef.current = null;
  }, []);

  return {
    isCompletingLtPlusSubscriptionRef,
    ltPlusSubscriptionIdRef,
    postLtPlusSpeculatedTransactionRef,
    handleBeginLtPlusSignup,
    handleEndLtPlusSignup,
  };
};
